import InsuranceImg from "../../../images/Insurance-and-executive-layout.png";
import React from "react";
import { Box, Container, Typography, Grid, Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";

const Insurance = () => {
  const navigate = useNavigate();

  // Hero Section with Background Image
  const HeroSection = () => (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: { xs: "50vh", md: "70vh" },
        backgroundImage: `url(${InsuranceImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
      }}
    >
      {/* Dark Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.45)",
        }}
      />

      {/* Content */}
      <Container
        sx={{
          position: "relative",
          zIndex: 2,
        }}
      >
        <Typography
          variant="overline"
          sx={{
            color: "#fff",
            letterSpacing: 2,
            opacity: 0.9,
          }}
        >
          Specialization
        </Typography>

        <Typography
          variant="h3"
          sx={{
            color: "#fff",
            fontWeight: 700,
            mt: 1,
            mb: 2, fontSize: { xs: "1.6rem", md: "2rem" },
          }}
        >
          Insurance & Executive
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "rgba(255,255,255,0.85)",
            maxWidth: 600,
            mb: 3,
          }}
        >
          Delivering comprehensive insurance and executive staffing solutions with
          experienced professionals committed to managing risk, ensuring compliance,
          and driving organizational success.
        </Typography>

        <Button
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          sx={{
            backgroundColor: "#1976d2",
            px: 4,
            py: 1.2,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "15px",
            "&:hover": {
              backgroundColor: "#115293",
            },
          }}
          onClick={() => navigate("/contact-us")}
        >
          Get in Touch
        </Button>
      </Container>
    </Box>
  );

  return (
    <Box>
      <HeroSection />

      {/* Insurance & Executive Jobs Section */}
      <Box
        sx={{
          py: { xs: 6, md: 10 },
          backgroundColor: "#f5f5f5",
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            align="center"
            sx={{
              fontWeight: 700,
              mb: { xs: 6, md: 8 },
              color: "#0a3b4a",
              fontSize: { xs: "2rem", md: "2.4rem" },

            }}
          >
            Insurance and Executive Jobs
          </Typography>

          {/* Row 1 */}
          <Grid container spacing={{ xs: 6, md: 8 }} sx={{ mb: { xs: 6, md: 10 } }}>
            {/* Insurance Agent */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography sx={{ fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, color: "#102a6b" }}>
                  Insurance and executive Jobs
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, color: "#102a6b" }}>
                  Insurance agent
                </Typography>
                <Typography variant="body2" sx={{
                  lineHeight: 1.7, fontSize: "15px",
                  fontWeight: 500
                }}>
                  Provides service to clients by selling life, health and disability
                  insurance. Builds long‑term client relationships, determines financial
                  needs, develops coordinated protection plans, communicates with
                  adjusters and completes underwriting applications and follow‑ups.
                </Typography>
                <Box sx={{ width: 0, height: 0, borderLeft: "120px solid transparent", borderRight: "120px solid transparent", borderTop: "80px solid #000", mx: "auto", mt: 4 }} />
              </Box>
            </Grid>

            {/* Insurance Claims Coordinator */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography sx={{ fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, color: "#102a6b" }}>
                  Insurance and executive Jobs
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, color: "#102a6b" }}>
                  Insurance claims coordinator
                </Typography>
                <Typography variant="body2" sx={{
                  lineHeight: 1.7, fontSize: "15px",
                  fontWeight: 500
                }}>
                  Reviews claim forms and records to determine coverage and liability,
                  coordinates inspections, communicates with customers and vendors,
                  follows up on claims, settles claims within guidelines and ensures
                  accurate claim payments.
                </Typography>
                <Box sx={{ width: 0, height: 0, borderLeft: "120px solid transparent", borderRight: "120px solid transparent", borderTop: "80px solid #000", mx: "auto", mt: 4 }} />
              </Box>
            </Grid>

            {/* Insurance Adjuster */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography sx={{ fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, color: "#102a6b" }}>
                  Insurance and executive Jobs
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, color: "#102a6b" }}>
                  Insurance adjuster
                </Typography>
                <Typography variant="body2" sx={{
                  lineHeight: 1.7, fontSize: "15px",
                  fontWeight: 500
                }}>
                  Investigates insurance claims by interviewing witnesses, reviewing
                  reports, estimating damages, researching repair costs, coordinating
                  contractors and negotiating settlements with claimants or legal teams.
                </Typography>
                <Box sx={{ width: 0, height: 0, borderLeft: "120px solid transparent", borderRight: "120px solid transparent", borderTop: "80px solid #000", mx: "auto", mt: 4 }} />
              </Box>
            </Grid>

            {/* Insurance Underwriter */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography sx={{ fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, color: "#102a6b" }}>
                  Insurance and executive Jobs
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, color: "#102a6b" }}>
                  Insurance underwriter
                </Typography>
                <Typography variant="body2" sx={{
                  lineHeight: 1.7, fontSize: "15px",
                  fontWeight: 500
                }}>
                  Reviews insurance proposals, evaluates risk, determines coverage terms,
                  prepares premiums, participates in continuing education and finalizes
                  policies based on competitive pricing and client requirements.
                </Typography>
                <Box sx={{ width: 0, height: 0, borderLeft: "120px solid transparent", borderRight: "120px solid transparent", borderTop: "80px solid #000", mx: "auto", mt: 4 }} />
              </Box>
            </Grid>
          </Grid>

          {/* Row 2 */}
          <Grid container spacing={{ xs: 6, md: 8 }}>
            {/* Insurance Verification Specialist */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography sx={{ fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, color: "#102a6b" }}>
                  Insurance and executive Jobs
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, color: "#102a6b" }}>
                  Insurance verification specialist
                </Typography>
                <Typography variant="body2" sx={{
                  lineHeight: 1.7, fontSize: "15px",
                  fontWeight: 500
                }}>
                  Verifies patient insurance coverage, confirms eligibility for medical
                  procedures, audits billing information, performs claims examinations and
                  educates clients on coverage benefits.
                </Typography>
                <Box sx={{ width: 0, height: 0, borderLeft: "120px solid transparent", borderRight: "120px solid transparent", borderTop: "80px solid #000", mx: "auto", mt: 4 }} />
              </Box>
            </Grid>

            {/* Insurance Investigator */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography sx={{ fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, color: "#102a6b" }}>
                  Insurance and executive Jobs
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, color: "#102a6b" }}>
                  Insurance investigator
                </Typography>
                <Typography variant="body2" sx={{
                  lineHeight: 1.7, fontSize: "15px",
                  fontWeight: 500
                }}>
                  Investigates insurance fraud by gathering forensic evidence, interviewing
                  witnesses, analyzing records, identifying suspicious activity and
                  preparing reports for prosecution or claim denial.
                </Typography>
                <Box sx={{ width: 0, height: 0, borderLeft: "120px solid transparent", borderRight: "120px solid transparent", borderTop: "80px solid #000", mx: "auto", mt: 4 }} />
              </Box>
            </Grid>

            {/* Insurance Executive */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography sx={{ fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, color: "#102a6b" }}>
                  Insurance and executive Jobs
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, color: "#102a6b" }}>
                  Insurance executive
                </Typography>
                <Typography variant="body2" sx={{
                  lineHeight: 1.7, fontSize: "15px",
                  fontWeight: 500
                }}>
                  Supports mergers and acquisitions, delivers market insights, liaises
                  with legal teams, builds client relationships, conducts presentations
                  and drives revenue growth through strategic initiatives.
                </Typography>
                <Box sx={{ width: 0, height: 0, borderLeft: "120px solid transparent", borderRight: "120px solid transparent", borderTop: "80px solid #000", mx: "auto", mt: 4 }} />
              </Box>
            </Grid>

            {/* Insurance Examiner */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography sx={{ fontWeight: 600, mb: 1, fontSize: { xs: "1.1rem", md: "1.3rem" }, color: "#102a6b" }}>
                  Insurance and executive Jobs
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "1.6rem", md: "2rem" }, color: "#102a6b" }}>
                  Insurance examiner
                </Typography>
                <Typography variant="body2" sx={{
                  lineHeight: 1.7, fontSize: "15px",
                  fontWeight: 500
                }}>
                  Reviews complex insurance claims, coordinates with reinsurers and legal
                  counsel, validates payments, maintains claim records and evaluates
                  questionable claims to determine authorization.
                </Typography>
                <Box sx={{ width: 0, height: 0, borderLeft: "120px solid transparent", borderRight: "120px solid transparent", borderTop: "80px solid #000", mx: "auto", mt: 4 }} />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default Insurance;

